import { UserContext, UserRole } from "../Provider";
import { useContext } from "react";

export const useUserMappingNotHaveRoles = () => {
	const user = useContext(UserContext);

	const handleMappingNoHaveRoles = (roles: UserRole[], notHave: boolean = false): boolean => {
		const countRoles =( user && user.roles.filter((e) => roles?.includes(e)).length )?? 0;
		const isCheck = notHave ? countRoles <= 0: countRoles> 0;
		if (user && isCheck) {
			return true;
		}
		return false;
	};
	return [ handleMappingNoHaveRoles];
};

export const useUserMappingRoles = () => {
	const user = useContext(UserContext);

	const handleMappingRoles = (roles: UserRole[]): boolean => {
		if (user && user.roles.filter((e) => roles?.includes(e)).length > 0) {
			return true;
		}
		return false;
	};

	const rolesAndPermissionByFirm = (
		roles: UserRole[],
		firmId?: number,
	): boolean => {
		if (!user) {
			return false;
		}

		if (user.roles.includes("Admin")) {
			return true;
		}

		if (
			firmId &&
			user.roles.filter((e) => roles.includes(e)).length > 0 &&
			firmId === user.individual.fkOrgId
		) {

			return true;
		}

		return false;
	};
	return [handleMappingRoles, rolesAndPermissionByFirm];
};

export const useUserMappingAdminRoles = () => {
	const user = useContext(UserContext);

	const handleMappingRoles = (roles: UserRole[]): boolean => {
		if (user && user.roles.filter((e) => roles?.includes(e)).length > 0) {
			return true;
		}
		return false;
	};

	const rolesAndPermissionByFirm = (
		roles: UserRole[],
		firmId?: number,
	): boolean => {
		if (!user) {
			return false;
		}

		if (user.roles.includes("Admin")) {
			return true;
		}

		if (
			firmId &&
			user.roles.filter((e) => roles.includes(e)).length > 0 &&
			firmId === user.individual.firmId
		) {

			return true;
		}

		return false;
	};
	return [handleMappingRoles, rolesAndPermissionByFirm];
};

